// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/workspace/v1/workspace_api.proto (package ai.h2o.workspace.v1, syntax proto3)
/* eslint-disable */

import type { Workspace } from "./workspace_pb";
import type { BigIntString } from "../../../../runtime";
import { RPC } from "../../../../runtime";
import type { WorkspaceImport } from "./import_pb";

/**
 * @generated from message ai.h2o.workspace.v1.GetWorkspaceRequest
 */
export type GetWorkspaceRequest = {
/**
 * Workspace name, e.g. "workspaces/<UUID>"
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.GetWorkspaceResponse
 */
export type GetWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CreateWorkspaceRequest
 */
export type CreateWorkspaceRequest = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
/**
 * The ID to use for the Workspace, which will become the final component of
 * the workspaces's resource name.
 *
 * This should be valid text representation of UUID.
 *
 * If no ID is specified, a random ID will be generated.
 *
 * @generated from field: string workspace_id = 2;
 */
workspaceId?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CreateWorkspaceResponse
 */
export type CreateWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UpdateWorkspaceRequest
 */
export type UpdateWorkspaceRequest = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
/**
 * Only the fields specified in update_mask will be updated.
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UpdateWorkspaceResponse
 */
export type UpdateWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.DeleteWorkspaceRequest
 */
export type DeleteWorkspaceRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.DeleteWorkspaceResponse
 */
export type DeleteWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UndeleteWorkspaceRequest
 */
export type UndeleteWorkspaceRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UndeleteWorkspaceResponse
 */
export type UndeleteWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ListWorkspacesRequest
 */
export type ListWorkspacesRequest = {
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return more or less items then specified.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
/**
 * When used, server will only return workspaces that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 * See https://github.com/h2oai/authz-server/blob/main/docs/adopting.md#filtering for specific supported
 * features.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *   * create_time
 *   * update_time
 *   * creator
 *   * updater
 *   * personal_workspace_subject
 *   * annotations
 *   * delete_time
 *   * deleter
 *   * purge_time
 *   * archiving_time
 *   * archiver
 *   * tags
 *   * labels
 *
 * Fields that are use for literal string matching:
 *  * display_name
 *  * description
 *
 * @generated from field: string filter = 4;
 */
filter?: string;
/**
 * When used, server will return workspaces ordered by the specified fields.
 * Attempts to implement AIP-132 (https://aip.dev/132#ordering).
 * Supported fields are the ones supported by filter except for annotations.
 *
 * @generated from field: string order_by = 5;
 */
orderBy?: string;
/**
 * When set to true, response will include also deleted workspaces.
 *
 * @generated from field: bool show_deleted = 6;
 */
showDeleted?: boolean;
/**
 * When set to true, response will include also archived workspaces.
 *
 * @generated from field: bool show_archived = 7;
 */
showArchived?: boolean;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ListWorkspacesResponse
 */
export type ListWorkspacesResponse = {
/**
 * @generated from field: repeated ai.h2o.workspace.v1.Workspace workspaces = 1;
 */
workspaces?: Workspace[];
/**
 * When not empty server has more results then returned. Use this value as
 * the page_token in the ListWorkspacesRequest to obtain next page of results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * See ListWorkspacesRequest for the documentation of the particular fields.
 *
 * @generated from message ai.h2o.workspace.v1.ListAllWorkspacesRequest
 */
export type ListAllWorkspacesRequest = {
/**
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
/**
 * @generated from field: string filter = 3;
 */
filter?: string;
/**
 * @generated from field: string order_by = 4;
 */
orderBy?: string;
/**
 * @generated from field: bool show_deleted = 5;
 */
showDeleted?: boolean;
/**
 * @generated from field: bool show_archived = 6;
 */
showArchived?: boolean;
}
;
/**
 * See ListWorkspacesResponse for the documentation of the particular fields.
 *
 * @generated from message ai.h2o.workspace.v1.ListAllWorkspacesResponse
 */
export type ListAllWorkspacesResponse = {
/**
 * @generated from field: repeated ai.h2o.workspace.v1.Workspace workspaces = 1;
 */
workspaces?: Workspace[];
/**
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CountWorkspacesRequest
 */
export type CountWorkspacesRequest = {
/**
 * When used, server will count only workspaces that match the filter.
 *
 * See ListWorkspacesRequest.filter for more details.
 *
 * @generated from field: string filter = 4;
 */
filter?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CountWorkspacesResponse
 */
export type CountWorkspacesResponse = {
/**
 * @generated from field: int64 total_size = 1;
 */
totalSize?: BigIntString;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ArchiveWorkspaceRequest
 */
export type ArchiveWorkspaceRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ArchiveWorkspaceResponse
 */
export type ArchiveWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UnarchiveWorkspaceRequest
 */
export type UnarchiveWorkspaceRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UnarchiveWorkspaceResponse
 */
export type UnarchiveWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ImportWorkspaceRequest
 */
export type ImportWorkspaceRequest = {
/**
 * @generated from field: ai.h2o.workspace.v1.WorkspaceImport import = 1;
 */
import?: WorkspaceImport;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.ImportWorkspaceResponse
 */
export type ImportWorkspaceResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.AddTagsRequest
 */
export type AddTagsRequest = {
/**
 * Workspace name, e.g. "workspaces/<UUID>".
 *
 * @generated from field: string workspace = 1;
 */
workspace?: string;
/**
 * Names of the tags to add to the workspace.
 *
 * @generated from field: repeated string tags = 2;
 */
tags?: string[];
}
;
/**
 * @generated from message ai.h2o.workspace.v1.AddTagsResponse
 */
export type AddTagsResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.RemoveTagsRequest
 */
export type RemoveTagsRequest = {
/**
 * Workspace name, e.g. "workspaces/<UUID>".
 *
 * @generated from field: string workspace = 1;
 */
workspace?: string;
/**
 * Names of the tags to remove from the workspace.
 *
 * @generated from field: repeated string tags = 2;
 */
tags?: string[];
}
;
/**
 * @generated from message ai.h2o.workspace.v1.RemoveTagsResponse
 */
export type RemoveTagsResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.AddLabelsRequest
 */
export type AddLabelsRequest = {
/**
 * Workspace name, e.g. "workspaces/<UUID>".
 *
 * @generated from field: string workspace = 1;
 */
workspace?: string;
/**
 * Names of the labels to add to the workspace.
 *
 * @generated from field: repeated string labels = 2;
 */
labels?: string[];
}
;
/**
 * @generated from message ai.h2o.workspace.v1.AddLabelsResponse
 */
export type AddLabelsResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.RemoveLabelsRequest
 */
export type RemoveLabelsRequest = {
/**
 * Workspace name, e.g. "workspaces/<UUID>".
 *
 * @generated from field: string workspace = 1;
 */
workspace?: string;
/**
 * Names of the labels to remove from the workspace.
 *
 * @generated from field: repeated string labels = 2;
 */
labels?: string[];
}
;
/**
 * @generated from message ai.h2o.workspace.v1.RemoveLabelsResponse
 */
export type RemoveLabelsResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Workspace workspace = 1;
 */
workspace?: Workspace;
}
;
/**
 * Returns details of the workspace specified by the name.
 *
 * Authorized by the "actions/workspaceserver/workspaces/GET" action on the
 * workspace resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.GetWorkspace
 */
export const WorkspaceService_GetWorkspace = new RPC<GetWorkspaceRequest,GetWorkspaceResponse>("GET", "/v1/{name=workspaces/*}");
/**
 * Creates a new workspace.
 *
 * Authorized by the "actions/workspaceserver/workspaces/CREATE" action on
 * the "//workspaceserver" resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.CreateWorkspace
 */
export const WorkspaceService_CreateWorkspace = new RPC<CreateWorkspaceRequest,CreateWorkspaceResponse>("POST", "/v1/workspaces", "workspace");
/**
 * Updates the workspace specified by the name.
 *
 * Authorized by the "actions/workspaceserver/workspaces/UPDATE" action on
 * the workspace resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.UpdateWorkspace
 */
export const WorkspaceService_UpdateWorkspace = new RPC<UpdateWorkspaceRequest,UpdateWorkspaceResponse>("PATCH", "/v1/{workspace.name=workspaces/*}", "workspace");
/**
 * Deletes the workspace specified by the name.
 *
 * Authorized by the "actions/workspaceserver/workspaces/DELETE" action on
 * the workspace resource.
 * Workspace is not deleted immediately, but marked as deleted and
 * purged after the retention period. Deleted workspace has delete_time and
 * purge_time set.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.DeleteWorkspace
 */
export const WorkspaceService_DeleteWorkspace = new RPC<DeleteWorkspaceRequest,DeleteWorkspaceResponse>("DELETE", "/v1/{name=workspaces/*}");
/**
 * Lists workspaces.
 *
 * Authorized by the "actions/workspaceserver/workspaces/LIST" action on the
 * "//workspaceserver" resource.
 * Server will return only workspaces that the caller has particular action
 * allowed on. This action is configurable and defaults to
 * "actions/workspaceserver/workspaces/LIST".
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.ListWorkspaces
 */
export const WorkspaceService_ListWorkspaces = new RPC<ListWorkspacesRequest,ListWorkspacesResponse>("GET", "/v1/workspaces");
/**
 * Lists all workspaces.
 *
 * Authorized by the "actions/workspaceserver/workspaces/LIST_ALL" action on
 * the "//workspaceserver" resource.
 * Returned workspaces are not further checked for the caller's permissions
 * and may not be accessible differently by the caller.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.ListAllWorkspaces
 */
export const WorkspaceService_ListAllWorkspaces = new RPC<ListAllWorkspacesRequest,ListAllWorkspacesResponse>("GET", "/v1/workspaces:listAll");
/**
 * Undeletes the workspace specified by the name if the workspace is deleted.
 *
 * Authorized by the "actions/workspaceserver/workspaces/UNDELETE" action on
 * the workspace resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.UndeleteWorkspace
 */
export const WorkspaceService_UndeleteWorkspace = new RPC<UndeleteWorkspaceRequest,UndeleteWorkspaceResponse>("POST", "/v1/{name=workspaces/*}:undelete");
/**
 * Returns number of workspaces that match the filter.
 *
 * WARNING: This method call is expensive and should be used sparingly.
 * Client-side caching is recommended to optimize the performance.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.CountWorkspaces
 */
export const WorkspaceService_CountWorkspaces = new RPC<CountWorkspacesRequest,CountWorkspacesResponse>("GET", "/v1/workspaces:count");
/**
 * Archives the workspace specified by the name.
 *
 * Authorized by the "actions/workspaceserver/workspaces/ARCHIVE" action on
 * the workspace resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.ArchiveWorkspace
 */
export const WorkspaceService_ArchiveWorkspace = new RPC<ArchiveWorkspaceRequest,ArchiveWorkspaceResponse>("POST", "/v1/{name=workspaces/*}:archive");
/**
 * Unarchives the workspace specified by the name.
 *
 * Authorized by the "actions/workspaceserver/workspaces/UNARCHIVE" action on
 * the workspace resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.UnarchiveWorkspace
 */
export const WorkspaceService_UnarchiveWorkspace = new RPC<UnarchiveWorkspaceRequest,UnarchiveWorkspaceResponse>("POST", "/v1/{name=workspaces/*}:unarchive");
/**
 * Imports a single workspace. Allows creation of the workspaces with the
 * output only fields set.
 * Fields and the state of the workspace is still validated.
 * When the workspace is imported, no permissions are set and caller is
 * responsible for setting them.
 * Caller requires 'actions/workspaceserver/workspaces/IMPORT' permission.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.ImportWorkspace
 */
export const WorkspaceService_ImportWorkspace = new RPC<ImportWorkspaceRequest,ImportWorkspaceResponse>("POST", "/v1/workspaces:importWorkspace");
/**
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.AddTags
 */
export const WorkspaceService_AddTags = new RPC<AddTagsRequest,AddTagsResponse>("POST", "/v1/{workspace=workspaces/*}:addTags");
/**
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.RemoveTags
 */
export const WorkspaceService_RemoveTags = new RPC<RemoveTagsRequest,RemoveTagsResponse>("POST", "/v1/{workspace=workspaces/*}:removeTags");
/**
 * Adds labels to the workspace.
 *
 * All of the labels must exist. Otherwise the call will fail with NOT_FOUND.
 * Labels already attached to the workspace are ignored.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.AddLabels
 */
export const WorkspaceService_AddLabels = new RPC<AddLabelsRequest,AddLabelsResponse>("POST", "/v1/{workspace=workspaces/*}:addLabels");
/**
 * Removes labels from the workspace.
 *
 * Removing non-attached or non-existing labels is no-op.
 *
 * @generated from rpc ai.h2o.workspace.v1.WorkspaceService.RemoveLabels
 */
export const WorkspaceService_RemoveLabels = new RPC<RemoveLabelsRequest,RemoveLabelsResponse>("POST", "/v1/{workspace=workspaces/*}:removeLabels");
